export const formatCardNumber = (num?: number) => {
  if (!num) return ''

  const str = String(num).replace(/\D/g, '')
  const groups: string[] = []

  let end = str.length

  // С конца: 3 группы по 2
  const lastGroups: string[] = []
  for (let j = 0; j < 3; j++) {
    if (end >= 2) {
      lastGroups.unshift(str.slice(end - 2, end))
      end -= 2
    }
    else if (end > 0) {
      lastGroups.unshift(str.slice(0, end))
      end = 0
    }
  }

  // Сначала по 4
  let start = 0
  while (start + 4 <= end) {
    groups.push(str.slice(start, start + 4))
    start += 4
  }

  // Остаток, если есть
  if (start < end) {
    groups.push(str.slice(start, end))
  }

  // Добавляем группы с конца
  return [ ...groups, ...lastGroups ].join(' ')
}
